import { CustomerVenueGroup } from "./CustomerVenueGroup.item";
import { CustomerVenueMarketingBlast } from "./CustomerVenueMarketingBlast.item";

export class MarketingBlast {
	pk: string; //venueKey
	sk: string; //:UUID
	templateKey: string;
	groupKeyList: string[];
	name: string;
	description: string;

	type: number;

	status: number;
	sendDate: string;
	sendDateUnix: number;
	sendDateDateFormat: Date;

	createdDate: string;

	sendCount: number;
	openCount: number;

	subject: string;
	fromName: string;
	replyToAddress: string;
	engagementStartDate: string;
	engagementEndDate: string;

	blastCustomers: CustomerVenueMarketingBlast[];

	blastStatusString: string;
	blastGroup: CustomerVenueGroup[];

	templateName: string;

	public constructor(init?: Partial<MarketingBlast>) {
		Object.assign(this, init);
	}
}
